/** Same prefix as useCashIntent; an entry means a cash step for this member may be unfinished. */
const CASH_INTENT_PREFIX = 'cash-intent-v1:';
/** Same key shape as useFinancialOperation for ZipaTransferPanel: an uncertain transfer request. */
const FINANCIAL_PREFIX = 'member-financial:';
const TRANSFER_ENDPOINT = 'zipa-transfers';

export function hasPendingCashIntent(
  memberId: string,
  storage: Pick<Storage, 'length' | 'key'> | undefined,
): boolean {
  if (!storage || !memberId) return false;
  try {
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (!key) continue;
      if (key.startsWith(CASH_INTENT_PREFIX) && key.includes(`:${memberId}:`)) return true;
      if (key.startsWith(FINANCIAL_PREFIX) && key.endsWith(`:${memberId}:${TRANSFER_ENDPOINT}`))
        return true;
    }
  } catch {
    // Unreadable storage cannot hold an intent this page could resume.
  }
  return false;
}
